import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';

/** @category Static Resources */
export function useStaticResources() {
  const tokenizedApi = useTokenizedApi();

  return useQuery(tokenizedApi?.staticResources.resourcesQuery())?.data;
}
